import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#42a5f5',
        secondary: '#fdd835',
        accent: '#8c9eff',
        error: '#b71c1c',
        noclicky: '#9e9e9e',
        subtle: '#aaa',
        background: '#FAFAFA',
        textPrimary: '#000000',
        textSecondary: '#000000'
      }
    },
    options: {
      customProperties: true
    }
  }
})
